<template>
  <b-overlay :show="Loading">
    <div class="my-register-page" style="font-size: 14px">
      <div class="my-container">
        <b-row class="mb-3 align-items-center">
          <b-col>
            <b-link class="xn-back" @click="GoBack">
              <b-icon icon="arrow-left"></b-icon>
              {{ $t("XabarnomaBackToList") }}
            </b-link>
          </b-col>
        </b-row>

        <b-row class="mb-2 align-items-center">
          <b-col>
            <span class="xn-type-badge" v-if="Detail.typeName">
              {{ Detail.typeName }}
            </span>
            <span
              class="xn-status ml-2"
              :class="'xn-status--' + StatusVariant(CurrentStatusId)"
              v-if="CurrentStatusName"
            >
              {{ CurrentStatusName }}
            </span>
          </b-col>
        </b-row>

        <h2 class="xn-subject mb-3">{{ Detail.subject }}</h2>

        <b-row>
          <b-col cols="12" lg="7">
            <!-- Xabarnoma tanasi -->
            <div class="cardStyleEdit mb-3 p-3">
              <div class="xn-org">
                <div class="xn-org__parent">
                  {{
                    Detail.senderOrganizationParentName ||
                    Detail.senderOrganizationName
                  }}
                </div>
                <div
                  class="xn-org__child"
                  v-if="
                    Detail.senderOrganizationParentName &&
                    Detail.senderOrganizationName
                  "
                >
                  {{ Detail.senderOrganizationName }}
                </div>
              </div>

              <hr />

              <b-row>
                <b-col cols="12" md="6" class="mb-3">
                  <div class="xn-label">{{ $t("XabarnomaNumber") }}</div>
                  <div class="xn-value">{{ Detail.docNumber || "—" }}</div>
                </b-col>
                <b-col cols="12" md="6" class="mb-3">
                  <div class="xn-label">{{ $t("XabarnomaSentDate") }}</div>
                  <div class="xn-value">{{ Detail.docDate || "—" }}</div>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-3"
                  v-if="Detail.isReplyRequired"
                >
                  <div class="xn-label">{{ $t("XabarnomaReplyDeadline") }}</div>
                  <div class="xn-value xn-value--danger">
                    {{ Detail.replyDeadlineDate || "—" }}
                  </div>
                </b-col>
              </b-row>

              <div class="xn-label">{{ $t("XabarnomaBody") }}</div>
              <div class="xn-body">{{ Detail.body }}</div>

              <!-- Xabarnoma ilovalari -->
              <div v-if="Detail.files && Detail.files.length" class="mt-3">
                <b-table-simple bordered responsive class="mb-0">
                  <b-thead>
                    <b-tr variant="primary">
                      <b-th style="width: 60px">№</b-th>
                      <b-th>{{ $t("fileName") }}</b-th>
                      <b-th class="text-center" style="width: 120px">
                        {{ $t("download") }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(file, fIndex) in Detail.files"
                      :key="file.id || fIndex"
                    >
                      <b-td>{{ fIndex + 1 }}</b-td>
                      <b-td>
                        <b-link @click="DownloadFile(file, false)">
                          {{ file.fileName || file.id }}
                        </b-link>
                      </b-td>
                      <b-td class="text-center">
                        <b-link @click="DownloadFile(file, false)">
                          <b-icon font-scale="1.2" icon="download"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>

            <!-- Yuborilgan javob -->
            <div class="cardStyleEdit mb-3 p-3" v-if="Detail.reply">
              <h5 class="styleText mb-2">{{ $t("XabarnomaReplyBlock") }}</h5>
              <b-row>
                <b-col cols="12" md="6" class="mb-2">
                  <div class="xn-label">{{ $t("XabarnomaReplyDate") }}</div>
                  <div class="xn-value">{{ Detail.reply.replyDate || "—" }}</div>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                  <div class="xn-label">{{ $t("XabarnomaReplyStatus") }}</div>
                  <div class="xn-value">
                    {{ Detail.reply.replyStatusName || "—" }}
                  </div>
                </b-col>
              </b-row>
              <div class="xn-label">{{ $t("XabarnomaReplyText") }}</div>
              <div class="xn-body">{{ Detail.reply.replyText }}</div>

              <div
                v-if="Detail.reply.files && Detail.reply.files.length"
                class="mt-3"
              >
                <b-table-simple bordered responsive class="mb-0">
                  <b-thead>
                    <b-tr variant="primary">
                      <b-th style="width: 60px">№</b-th>
                      <b-th>{{ $t("fileName") }}</b-th>
                      <b-th class="text-center" style="width: 120px">
                        {{ $t("download") }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(file, fIndex) in Detail.reply.files"
                      :key="file.id || fIndex"
                    >
                      <b-td>{{ fIndex + 1 }}</b-td>
                      <b-td>
                        <b-link @click="DownloadFile(file, true)">
                          {{ file.fileName || file.id }}
                        </b-link>
                      </b-td>
                      <b-td class="text-center">
                        <b-link @click="DownloadFile(file, true)">
                          <b-icon font-scale="1.2" icon="download"></b-icon>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>

            <div class="mb-4" v-if="CanReply">
              <b-button variant="primary" @click="GoToReply">
                {{ $t("XabarnomaReply") }}
              </b-button>
            </div>
          </b-col>

          <b-col cols="12" lg="5">
            <!-- Holat tarixi -->
            <div class="cardStyleEdit mb-3 p-3">
              <h5 class="styleText mb-3">{{ $t("XabarnomaHistory") }}</h5>
              <div class="xn-timeline">
                <div
                  class="xn-timeline__item"
                  v-for="(item, index) in Detail.history"
                  :key="index"
                >
                  <span class="xn-timeline__dot"></span>
                  <div class="xn-timeline__title" v-if="item.statusName">
                    {{ item.statusName }}
                  </div>
                  <div class="xn-timeline__title" v-else>
                    {{ $t("comment") }}
                  </div>
                  <div class="xn-timeline__date">{{ item.dateOfCreated }}</div>
                  <div class="xn-timeline__text" v-if="item.comment">
                    {{ item.comment }}
                  </div>
                  <div
                    class="xn-timeline__text"
                    v-if="item.senderEmployeeName"
                  >
                    {{ $t("employee") }}: {{ item.senderEmployeeName }}
                    <template v-if="item.senderEmployeeUserName">
                      (login: {{ item.senderEmployeeUserName
                      }}<template v-if="item.senderEmployeePinfl">
                        , {{ $t("pinfl") }}: {{ item.senderEmployeePinfl }}
                      </template>)
                    </template>
                  </div>
                </div>
                <div
                  v-if="!Detail.history || !Detail.history.length"
                  class="text-muted"
                >
                  {{ $t("noData") }}
                </div>
              </div>
            </div>

            <!-- SMS ogohlantirishi -->
            <div class="xn-sms mb-3" v-if="Detail.smsSent">
              <div class="xn-label">{{ $t("XabarnomaSmsTitle") }}</div>
              <div>{{ $t("XabarnomaSmsText") }}</div>
            </div>

            <!-- Izoh qoldirish -->
            <div class="cardStyleEdit mb-3 p-3">
              <h5 class="styleText mb-2">{{ $t("XabarnomaAddComment") }}</h5>
              <custom-textarea
                v-model="comment"
                :rows="4"
                :label="''"
                :placeholder="$t('XabarnomaCommentPlaceholder')"
              />
              <div class="text-right mt-2">
                <b-button
                  variant="outline-primary"
                  :disabled="CommentSaving || !comment.trim()"
                  @click="AddComment"
                >
                  <b-spinner v-if="CommentSaving" small></b-spinner>
                  {{ $t("XabarnomaCommentAdd") }}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BOverlay,
  BSpinner,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIcon,
  BLink,
} from "bootstrap-vue";
import customTextarea from "@/components/elements/customTextarea.vue";
import XabarnomaService from "@/services/xabarnoma.service";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BOverlay,
    BSpinner,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIcon,
    BLink,
    customTextarea,
  },
  data() {
    return {
      Loading: false,
      CommentSaving: false,
      comment: "",
      Detail: {},
    };
  },
  created() {
    this.Refresh();
  },
  computed: {
    RecipientId() {
      return this.$route.params.id;
    },
    // Holat tarixidagi oxirgi status — sarlavha yonidagi belgi uchun.
    LastStatus() {
      const history = this.Detail.history || [];
      for (let i = history.length - 1; i >= 0; i--) {
        if (history[i].statusId) return history[i];
      }
      return null;
    },
    CurrentStatusId() {
      return this.LastStatus ? this.LastStatus.statusId : null;
    },
    CurrentStatusName() {
      return this.LastStatus ? this.LastStatus.statusName : "";
    },
    CanReply() {
      return !!this.Detail.isReplyRequired && !this.Detail.reply;
    },
  },
  methods: {
    StatusVariant(statusId) {
      switch (statusId) {
        case 1:
        case 2:
          return "new";
        case 3:
          return "read";
        case 4:
          return "awaiting";
        case 5:
          return "replied";
        case 6:
          return "expired";
        default:
          return "default";
      }
    },
    GoBack() {
      this.$router.push({ name: "xabarnoma" });
    },
    GoToReply() {
      this.$router.push({
        name: "XabarnomaReply",
        params: { id: this.RecipientId },
      });
    },
    Refresh() {
      this.Loading = true;
      // GetDetail chaqirilganda backend holatni o'zi "O'qildi"ga o'tkazadi.
      XabarnomaService.GetDetail(this.RecipientId)
        .then((res) => {
          this.Detail = res.data || {};
          this.Loading = false;
        })
        .catch((error) => {
          this.Loading = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    AddComment() {
      const text = this.comment.trim();
      if (!text) return;
      this.CommentSaving = true;
      XabarnomaService.AddRecipientComment(this.RecipientId, text)
        .then(() => {
          this.CommentSaving = false;
          this.comment = "";
          this.makeToast(this.$t("XabarnomaCommentSuccess"), "success");
          this.Refresh();
        })
        .catch((error) => {
          this.CommentSaving = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    DownloadFile(file, isReplyFile) {
      if (!file || !file.id) return;
      const request = isReplyFile
        ? XabarnomaService.DownloadReplyFile(file.id)
        : XabarnomaService.DownloadFile(file.id);
      request
        .then((res) => {
          const contentType =
            (res.headers && res.headers["content-type"]) ||
            "application/octet-stream";
          const blob =
            res.data instanceof Blob
              ? res.data
              : new Blob([res.data], { type: contentType });

          let filename = file.fileName || "";
          const disposition = res.headers && res.headers["content-disposition"];
          if (disposition) {
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
            if (utf8Match) {
              filename = decodeURIComponent(utf8Match[1]);
            } else if (asciiMatch) {
              filename = asciiMatch[1];
            }
          }
          if (!filename) filename = file.id;

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.xn-back {
  color: $primary-dark;
  font-weight: 600;
  cursor: pointer;
}

.xn-subject {
  font-weight: 700;
}

.xn-type-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  background: #eaf2ff;
  color: $primary;
}

.xn-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  background: #f0f0f0;
  color: #4b5563;

  &--new {
    background: #fff7e8;
    color: #b4740e;
  }
  &--read {
    background: #f0f0f0;
    color: #4b5563;
  }
  &--awaiting {
    background: #eaf2ff;
    color: $primary;
  }
  &--replied {
    background: #e9f7ef;
    color: #1a7f47;
  }
  &--expired {
    background: #fdeaef;
    color: $danger;
  }
}

.xn-org__parent {
  font-weight: 700;
}

.xn-org__child {
  color: #6b7280;
}

.xn-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
}

.xn-value {
  font-weight: 600;

  &--danger {
    color: $danger;
  }
}

.xn-body {
  white-space: pre-line;
  line-height: 1.6;
}

.xn-sms {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f7f7f7;
  padding: 14px 16px;
}

.xn-timeline {
  position: relative;
}

.xn-timeline__item {
  position: relative;
  padding-left: 22px;
  padding-bottom: 18px;

  &:not(:last-child)::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 14px;
    bottom: 0;
    width: 2px;
    background: #e5e7eb;
  }
}

.xn-timeline__dot {
  position: absolute;
  left: 0;
  top: 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: $primary;
}

.xn-timeline__title {
  font-weight: 700;
}

.xn-timeline__date,
.xn-timeline__text {
  color: #6b7280;
  font-size: 13px;
}

.cardStyleEdit {
  padding: 5px;
  background-color: #eaf2ff;
  border-radius: 5px;
}

.styleText {
  font-weight: 900;
  font-size: 16px;
}
</style>
